import { HTMLAttributes } from 'react'

import Legals from '@/components/base/legals'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type ColophonProps = HTMLAttributes<HTMLDivElement>

const Colophon = ({ className, ...props }: ColophonProps) => {
  const { strings } = useStore()

  return (
    <div className={cn('grid gap-spacing-xs', className)} {...props}>
      <div className="flex">
        <Typography variant="small" className="text-current">
          {strings?.footer?.copyright.replace('[YEAR]', new Date().getFullYear().toString())}
        </Typography>
      </div>

      <Legals />
    </div>
  )
}

export default Colophon
